import React from 'react'
import { Trans } from '@lingui/react'
import OptionGroup from './OptionGroup.js'

const OptionGroupQuestion = ({ options }) => {
  const min = options[0]
  const max = options[options.length - 1]

  return (
    <div>
      <div className="small lh-medium faded mobile-smaller">
        <Trans>
          <div>Choose a number between</div>
          <div>
            <strong>
              {min.value} ({min.body})
            </strong>{' '}
            and{' '}
            <strong>
              {max.value} ({max.body})
            </strong>.
          </div>
        </Trans>
      </div>
      <OptionGroup options={options} />
    </div>
  )
}

export default OptionGroupQuestion



// WEBPACK FOOTER //
// ./src/components/OptionGroupQuestion.js